module.exports = __webpack_public_path__ + "static/media/zxyjh.cab8e405.png";